import React from 'react';
import { Col, Form } from 'react-bootstrap';

import {ContentRoute} from "_metronic/layout";

import AppContext from 'app/AppContext';
import Module from "app/modules/Module";

let yup = require('yup');

export default class SocialType extends Module {
    info = SocialType.Info;
    
    static Info = {
        nameResource: "social-types",
        icon: "fas fa-asterisk admin-menus-color",
        path: "/socialtypes",
        show: true
    };

    static get route() {
        return  <ContentRoute key={this.Info.path} path={this.Info.path + "/:id?"} 
                    component={(props) => <SocialType match={props.match} location={props.location} history={props.history} />} />;
    }

    get title () {
        return AppContext.r["social-type"];
    }

    get apiPath() {
      return '/socials/types';
    }
    
    get schema () {
        return yup.object({
            name: yup.string().required()
        });
    }

    get tableHead () {
        return [
            {
                "Title": AppContext.r["id"],
                "Field": "id",
                "ClassName": "d-none d-sm-table-cell",
            },
            {
                "Title": AppContext.r["name"],
                "Field": "name"
            },
            {
                "Title": AppContext.r["description"],
                "Field": "description"
            }
        ];
    }

    get initialValues() {
        return {
            name: "",
            descriptions: "",
        };
    }

    get mask () {
        return ({ handleSubmit, handleChange, values, touched, errors }) => (
            <Form onSubmit={handleSubmit}>
                <Form.Row>
                    <Form.Group as={Col} xs="10">
                        <Form.Label>{AppContext.r["name"]}*</Form.Label>
                        <Form.Control type="text" placeholder={AppContext.r["name"]} name="name"
                                        value={values.name} onChange={handleChange}
                                        isValid={touched.name && !errors.name} isInvalid={!!errors.name} />
                    </Form.Group>
                </Form.Row>        
                
                <Form.Row>
                    <Form.Group as={Col} xs="9">
                        <Form.Label>{AppContext.r["description"]}</Form.Label>
                        <Form.Control type="text" placeholder={AppContext.r["description"]} name="description"
                                        value={values.description} onChange={handleChange} />
                    </Form.Group>
                </Form.Row>
                
                {/* Shown only on editing */}
                <Form.Row style={this.displayOnEditStyle}>
                    <Form.Group as={Col}>
                        <p className="item-id-is-label">{AppContext.r["item-id-is"]} </p>
                        <Form.Control type="text" placeholder={AppContext.r["id"]} name="id" disabled className="item-id-is-control"
                                        value={values.id} />
                    </Form.Group>
                </Form.Row>

                {this.formFooter}
            </Form>);
    }
}